// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { Badge, Link } from '@shopify/polaris';
import * as AppIntegrationActions from 'actions/app-integration-actions';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

class ProductLabelsCard extends Component<ComposedProps> {
  render() {
    const { i18n, data = {}, index, currentAppIntegration } = this.props;

    const {
      icon,
      name,
      appType,
      appName,
      integration,
      appListingURL,
      description,
      instructionURL,
      iconStyle
    } = data;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <a className="Polaris-Link" href={appListingURL} target="_blank" rel="noopener noreferrer">
          <img
            className="icon"
            src={icon}
            alt={i18n.translate(name)}
            style={iconStyle ? iconStyle : {}}
          />
        </a>
        {/* Integration type */}
        {enableShopifyIntegration && integration && (
          <div className="integration">
            <Badge status="info">{i18n.translate(integration)}</Badge>
          </div>
        )}
        {/* App name */}
        <div className="name">{i18n.translate(name)}</div>

        {/* App description */}
        <div className="description">{i18n.translate(description)}</div>

        {/*Enable/Disable app key*/}
        {enableShopifyIntegration && (
          <label className="BC-Checkbox-Status">
            <input
              type="checkbox"
              checked={currentAppIntegration[appType] === appName}
              onChange={() => this.handleChange(appType, appName)}
            />
            <span />
          </label>
        )}

        {/* App instruction */}
        <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div>
      </div>
    );
  }

  // Change status
  handleChange = (appType, appName) => {
    const { currentAppIntegration } = this.props;

    this.props.handleChangeApp(currentAppIntegration, appType, appName);
  };
}

const mapDispatchToProps = dispatch => ({
  handleChangeApp: (currentAppIntegration, appType, appName) =>
    dispatch(AppIntegrationActions.handleChangeApp(currentAppIntegration, appType, appName))
});

const mapStateToProps = state => {
  const currentAppIntegration = _.get(state.oauth.tenantApp, 'currentAppIntegration', {});

  return {
    currentAppIntegration
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ProductLabelsCard));
